import React, { PureComponent, ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { AnyAction } from 'redux'
import { connectRedux } from '../../../helpers/connectRedux'
import { RouteComponentProps, withRouter } from '../../../helpers/withRouter'
import { Page } from '../../../components'
import LanguageSelector from '../../../containers/LanguageSelector'
import { VerificationStepForm } from '../../../containers/VerificationForms'
import { images } from '../../../images'
import { urls } from '../../../routing'
import { LiteralsService } from '../../../services'
import { IStoreState } from '../../../store/states'
import StyledArticle from '../styles'
import { appsLogosSelected, appsStyleSelected } from '../../../helpers/app'

interface IProps extends DispatchProp<AnyAction>, RouteComponentProps {
  language: string
  embedded?: boolean
}

// The form itself lives in the container, shared with the prompt shown to guests.
class AccountVerificationStep extends PureComponent<IProps> {
  public render(): ReactNode {
    if (this.props.embedded) return this.card

    return (
      <Page className={ appsStyleSelected?.style }>
        <StyledArticle>
          <div className="language-selector">
            <LanguageSelector />
          </div>
          { this.card }
        </StyledArticle>
      </Page>
    )
  }

  private get card(): ReactNode {
    return (
      <form onSubmit={ e => e.preventDefault() }>
        <img src={ images['goBack'] } className="backButton" onClick={ this.handleGoBack } alt="" />
        <header>
          <img  className={ appsLogosSelected?.classRounded }
                src={ appsLogosSelected?.logoRounded }
                alt={ appsLogosSelected?.alt } />
          <h2>{ LiteralsService.get('verifyYourEmail', true) }</h2>
        </header>
        <VerificationStepForm onResend={ this.goToNewConfirmationCode } />
      </form>
    )
  }

  private goToNewConfirmationCode = (): void => {
    this.props.history.push(urls.accountVerificationResend)
  }

  // Explicit destination rather than history.back(): the screen can be opened by URL.
  private handleGoBack = (): void => {
    this.props.history.push(urls.signIn)
  }
}

const mapStateToProps = ({ configuration }: IStoreState) => ({
  // Redraws the literals when the language selector changes the language.
  language: configuration.language
})

export default withRouter(connectRedux(mapStateToProps, AccountVerificationStep))
